import { useEffect, useMemo, useState } from 'react';

export default function HeroCarousel({ slides, interval = 6000 }) {
  const normalizedSlides = useMemo(() => slides.filter(Boolean), [slides]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!normalizedSlides.length) return undefined;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % normalizedSlides.length);
    }, interval);
    return () => clearInterval(timer);
  }, [normalizedSlides, interval]);

  if (!normalizedSlides.length) return null;

  return (
    <div className="hero-carousel">
      {normalizedSlides.map((slide, slideIndex) => (
        <figure
          key={slide.id || `slide-${slideIndex}`}
          className={`hero-carousel__slide${slideIndex === index ? ' hero-carousel__slide--active' : ''}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          <figcaption className="hero-carousel__caption">
            <p className="hero-carousel__club">Unisport du Haut-Nkam</p>
            <h1>{slide.headline}</h1>
            <p>{slide.subline}</p>
          </figcaption>
        </figure>
      ))}
      <div className="hero-carousel__indicators">
        {normalizedSlides.map((slide, slideIndex) => (
          <button
            key={`${slide.id || `slide-${slideIndex}`}-indicator`}
            type="button"
            aria-label={`Aller à la diapositive ${slideIndex + 1}`}
            className={slideIndex === index ? 'is-active' : ''}
            onClick={() => setIndex(slideIndex)}
          />
        ))}
      </div>
    </div>
  );
}
